import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { legalPages } from './legalContent';
import './Legal.css';

const VALID_SLUGS = ['terms', 'privacy', 'accessibility', 'cookies', 'sitemap'];

export default function Legal() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [cookiesAnalytics, setCookiesAnalytics] = useState(true);
  const [cookiesMarketing, setCookiesMarketing] = useState(false);

  const normalizedSlug = slug ? slug.toLowerCase() : '';
  const page = VALID_SLUGS.includes(normalizedSlug) ? legalPages[normalizedSlug] : null;

  useEffect(() => {
    if (!page) navigate('/', { replace: true });
  }, [page, navigate]);
  if (!page) return null;

  const isCookies = normalizedSlug === 'cookies';

  return (
    <div className="legal-page">
      <div className="legal-inner">
        <Link to="/" className="legal-back">← Back to Home</Link>
        <h1 className="legal-title">{page.title}</h1>
        <p className="legal-updated">Last updated: {page.lastUpdated}</p>

        <div className="legal-content">
          {page.sections.map((section, i) => (
            <section key={i} className="legal-section">
              <h2 className="legal-section-heading">{section.heading}</h2>
              <p className="legal-section-body">{section.body}</p>
            </section>
          ))}

          {isCookies && (
            <section className="legal-section legal-cookie-settings">
              <h2 className="legal-section-heading">Manage preferences</h2>
              <div className="legal-cookie-options">
                <label className="legal-cookie-option">
                  <span>Essential cookies</span>
                  <span className="legal-cookie-badge">Always on</span>
                </label>
                <label className="legal-cookie-option">
                  <input
                    type="checkbox"
                    checked={cookiesAnalytics}
                    onChange={(e) => setCookiesAnalytics(e.target.checked)}
                  />
                  <span>Analytics cookies</span>
                </label>
                <label className="legal-cookie-option">
                  <input
                    type="checkbox"
                    checked={cookiesMarketing}
                    onChange={(e) => setCookiesMarketing(e.target.checked)}
                  />
                  <span>Marketing cookies</span>
                </label>
              </div>
              <button type="button" className="legal-save-btn" onClick={() => alert('Preferences saved.')}>
                Save cookie preferences
              </button>
            </section>
          )}
        </div>

        <nav className="legal-nav">
          <p className="legal-nav-title">Other information</p>
          <ul>
            <li><Link to="/legal/terms">Terms of Use</Link></li>
            <li><Link to="/legal/privacy">Privacy Policy</Link></li>
            <li><Link to="/legal/accessibility">Accessibility Statement</Link></li>
            <li><Link to="/legal/cookies">Cookie settings</Link></li>
            <li><Link to="/legal/sitemap">Sitemap</Link></li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
